<app-audit-subbar></app-audit-subbar>

<div class="audit-tab-body" style="position: relative">
<div class="ov-wrap">

  <!-- ===== LOADING STATE ===== -->
  <div class="ov-loader-section" *ngIf="showLoader && !noData">
    <div class="ov-loader-svg">
      <svg
        width="200"
        height="161"
        viewBox="0 0 200 161"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M46 47.5L71.5 62.5L97.5 47.5V17L71.5 2L46 17V47.5Z"
          [style.stroke]="loaderPercentage > 10 ? '#8680ff' : '#c9c6cc'"
          stroke-width="1.5"
        />
        <path
          d="M18 96.5L43.5 111.5L69.5 96.5V66L43.5 51L18 66V96.5Z"
          [style.stroke]="loaderPercentage > 20 ? '#8680ff' : '#c9c6cc'"
          stroke-width="1.5"
        />
        <path
          d="M102 46.5L127.5 61.5L153.5 46.5V16L127.5 1L102 16V46.5Z"
          [style.stroke]="loaderPercentage > 30 ? '#8680ff' : '#c9c6cc'"
          stroke-width="1.5"
        />
        <path
          d="M75 95.5L100.5 110.5L126.5 95.5V65L100.5 50L75 65V95.5Z"
          [style.stroke]="loaderPercentage > 35 ? '#8680ff' : '#c9c6cc'"
          stroke-width="1.5"
        />
        <path
          d="M102 144.5L127.5 159.5L153.5 144.5V114L127.5 99L102 114V144.5Z"
          [style.stroke]="loaderPercentage > 40 ? '#8680ff' : '#c9c6cc'"
          stroke-width="1.5"
        />
        <path
          d="M107 75L98 84.5L93.5 80"
          [style.stroke]="loaderPercentage > 50 ? '#8680ff' : '#c9c6cc'"
          stroke-width="1.5"
        />
        <path
          d="M131 95.5L156.5 110.5L182.5 95.5V65L156.5 50L131 65V95.5Z"
          [style.stroke]="loaderPercentage > 60 ? '#8680ff' : '#c9c6cc'"
          stroke-width="1.5"
        />
        <path
          d="M46 144.5L71.5 159.5L97.5 144.5V114L71.5 99L46 114V144.5Z"
          [style.stroke]="loaderPercentage > 70 ? '#8680ff' : '#c9c6cc'"
          stroke-width="1.5"
        />
        <path
          d="M1 137.818L14.8641 146L29 137.818V121.182L14.8641 113L1 121.182V137.818Z"
          [style.stroke]="loaderPercentage > 80 ? '#8680ff' : '#c9c6cc'"
          stroke-width="1.5"
        />
        <path
          d="M171 38.8182L184.864 47L199 38.8182V22.1818L184.864 14L171 22.1818V38.8182Z"
          [style.stroke]="loaderPercentage > 90 ? '#8680ff' : '#c9c6cc'"
          stroke-width="1.5"
        />
      </svg>
    </div>
    <div class="multi_lines_loading_text_container">
      <div class="multi_lines_loading_text">
        <p
          *ngFor="let message of loaderTexts; let i = index"
          [ngClass]="{
            active: i == loaderLineIndex,
            before: i < loaderLineIndex,
            after: i > loaderLineIndex,
          }"
        >
          {{ message }}
        </p>
      </div>
    </div>
  </div>

  <!-- ===== NO DATA STATE ===== -->
  <div class="ov-empty" *ngIf="noData">
    <p>You don't have any audits yet.</p>
    <div class="custom-buttons_container">
      <button mat-raised-button type="button" (click)="addAudit()">
        <mat-icon class="button-icon">add</mat-icon>
        <span>Create Audit</span>
      </button>
    </div>
  </div>

  <!-- ===== MAIN CONTENT ===== -->
  <ng-container *ngIf="!showLoader && !noData && overviewData">
    <!-- ── Executive Summary ── -->
    <div class="exec-card">
      <div class="exec-card-header">
        <span class="exec-dot"></span>
        <span class="exec-label">EXECUTIVE SUMMARY</span>
      </div>

      <p class="exec-summary-text" *ngIf="summaryHeadline || summaryText">
        <b *ngIf="summaryHeadline">{{ summaryHeadline }}</b>
        <span *ngIf="summaryText"> {{ summaryText }}</span>
      </p>

      <div class="kpi-grid">
        <!-- Overall Health -->
        <div class="kpi-card">
          <div class="kpi-name">Overall Health</div>
          <div class="kpi-val-row">
            <span class="kpi-val">{{ kpiHealth }}</span>
            <span class="kpi-unit">/100</span>
            <span
              class="kpi-delta"
              *ngIf="kpiHealthDelta !== null && kpiHealthDelta !== 0"
              [style.color]="kpiHealthDelta > 0 ? green : red"
            >
              {{
                kpiHealthDelta > 0
                  ? "▲ +" + kpiHealthDelta
                  : "▼ " + -kpiHealthDelta
              }}
            </span>
          </div>
          <div class="kpi-spark" *ngIf="kpiHealthSpark.length > 1">
            <audit-sparkline
              [values]="kpiHealthSpark"
              [color]="accent"
            ></audit-sparkline>
          </div>
          <div class="kpi-hint">vs last period</div>
        </div>

        <!-- Open Issues -->
        <div class="kpi-card">
          <div class="kpi-name">Open Issues</div>
          <div class="kpi-val-row">
            <span class="kpi-val">{{ kpiOpenIssues }}</span>
            <span
              class="kpi-delta"
              *ngIf="kpiOpenDelta !== null && kpiOpenDelta !== 0"
              [style.color]="kpiOpenDelta < 0 ? green : red"
            >
              {{
                kpiOpenDelta < 0 ? "▼ " + -kpiOpenDelta : "▲ +" + kpiOpenDelta
              }}
            </span>
          </div>
          <div class="kpi-spark" *ngIf="kpiOpenSpark.length > 1">
            <audit-sparkline
              [values]="kpiOpenSpark"
              [color]="green"
            ></audit-sparkline>
          </div>
          <div class="kpi-hint">net change vs last period</div>
        </div>

        <!-- Market Position -->
        <div class="kpi-card">
          <div class="kpi-name">Market Position</div>
          <div class="kpi-val-row">
            <span class="kpi-val kpi-rank" style="margin-top: 15px"
              >{{ kpiRank
              }}<span class="kpi-rank-suffix">{{
                kpiRank === 1
                  ? "st"
                  : kpiRank === 2
                    ? "nd"
                    : kpiRank === 3
                      ? "rd"
                      : "th"
              }}</span></span
            >
            <span class="kpi-unit"
              >of {{ kpiRankTotal }}
              {{ kpiRankTotal === 1 ? "site" : "sites" }}</span
            >
          </div>
          <div class="kpi-hint kpi-hint--mt">{{ kpiRankNote }}</div>
        </div>
      </div>
    </div>

    <!-- ── Category Scores ── -->
    <div class="cat-section">
      <div class="section-header">
        <h3 class="section-title">Category scores</h3>
        <span class="section-hint"
          >click a category for the full benchmark · score · trend · vs
          last</span
        >
      </div>

      <div class="cat-grid">
        <div
          *ngFor="let card of catCards"
          class="cat-card"
          [class.cat-card--clickable]="card.tabIndex !== null && !card.failed"
          (click)="!card.failed && goToTabIndex(card.tabIndex)"
        >
          <div class="cat-top">
            <span class="cat-name">{{ card.label }}</span>
            <span
              class="cat-badge"
              *ngIf="card.status !== 'Warning'"
              [style.color]="card.statusColor"
              [style.background]="card.statusBg"
            >
              {{ card.status }}
            </span>
          </div>

          <div class="cat-score-row">
            <span class="cat-score">{{
              card.failed ? "N/A" : card.score
            }}</span>
            <span class="cat-unit" *ngIf="!card.failed">/100</span>
          </div>

          <div
            class="cat-spark"
            *ngIf="!card.failed && card.spark.length > 1 && !card.sparkFlat"
          >
            <audit-sparkline
              [values]="card.spark"
              [color]="card.sparkColor"
            ></audit-sparkline>
          </div>

          <!-- Empty spacer keeps SEO/GEO (no trend series) height-aligned with
               cards that have a sparkline, without drawing a flat trend line. -->
          <div
            class="cat-spark cat-spark--flat"
            *ngIf="isBiweekly && !card.failed && card.spark.length <= 1"
          ></div>

          <div class="cat-mid" *ngIf="!card.failed">
            <span class="cat-delta" [style.color]="card.deltaColor"
              >{{ card.deltaArrow }} {{ card.deltaText }}</span
            >
            <span class="cat-open">{{ card.issues }} open</span>
          </div>

          <div
            class="cat-vs"
            *ngIf="!card.failed && card.hasComp"
            [style.color]="card.vsColor"
          >
            {{ card.vsArrow }} {{ card.vsText }}
          </div>
          <div class="cat-vs cat-vs--missing" *ngIf="card.compMissing">
            Competitor couldn't be crawled
          </div>
        </div>
      </div>
    </div>

    <!-- ── Overall score over time (biweekly audits with >1 data point only;
         hidden for one-time audits and single-point histories) ── -->
    <div class="trend-card" *ngIf="overallHasData">
      <div class="trend-head">
        <div>
          <h3 class="section-title">Overall score over time</h3>
          <p class="trend-sub">
            Your trajectory against tracked competitors
          </p>
        </div>

        <!-- Interactive legend: toggle each competitor line on/off (#14/#15).
             "Your site" is always shown. -->
        <div class="trend-legend" *ngIf="trendSeries.length > 1">
          <button
            *ngFor="let s of trendSeries"
            type="button"
            class="trend-legend-chip"
            [class.off]="!s.isYou && !s.visible"
            [class.locked]="s.isYou"
            (click)="toggleTrendSeries(s.key)"
          >
            <span class="trend-legend-dash" [style.background]="s.color"></span>
            {{ s.label }}
          </button>
        </div>
      </div>
      <div class="trend-body">
        <google-chart [data]="overallLineChart"></google-chart>
      </div>
    </div>

    <!-- ── Bottom two-column grid ── -->
    <div class="ov-bottom-grid">
      <!-- Critical Issues -->
      <div class="bottom-card" *ngIf="topCriticalIssues.length">
        <h3 class="card-title">Where are you losing revenue?</h3>
        <div class="issue-list">
          <div *ngFor="let issue of topCriticalIssues" class="issue-row">
            <div
              class="issue-icon"
              [style.color]="issue.sevColor"
              [style.background]="issue.sevBg"
            >
              <svg class="issue-icon-svg" viewBox="0 0 603 618" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M185 0L149.99 34.9609L194.961 79.9805L22.5 252.49C-7.5 282.49 -7.5 329.961 22.5 359.961L24.9902 362.5L182.461 519.971C212.461 549.971 259.98 549.971 289.98 519.971L479.971 329.98L497.5 312.5L254.971 69.9707L235 50L229.971 44.9707L185 0ZM229.971 114.99L427.48 312.5L372.5 367.48H99.9414L57.4609 325C47.4609 315 47.4609 297.5 57.4609 287.5L229.971 114.99ZM527.48 400L507.461 429.98C507.461 429.98 494.971 449.961 479.971 472.461C472.471 484.961 467.49 494.971 462.49 507.471C457.49 519.971 452.48 527.48 452.48 542.48C452.48 582.48 487.48 617.48 527.48 617.48C567.48 617.48 602.48 582.48 602.48 542.48C602.48 527.48 597.471 517.48 592.471 504.98C587.471 492.48 579.99 479.971 574.99 469.971C562.49 447.471 547.5 427.49 547.5 427.49L527.48 400Z"
                />
              </svg>
            </div>
            <div class="issue-body">
              <div class="issue-title">{{ issue.title }}</div>
              <div
                class="issue-desc"
                *ngIf="issue.desc"
                [matTooltip]="issue.desc"
                matTooltipPosition="above"
                matTooltipClass="multiline-tooltip"
              >
                {{ issue.desc }}
              </div>
            </div>
            <span
              class="issue-cat"
              [style.color]="issue.catColor"
              [style.border-color]="issue.catBorder"
              >{{ issue.category }}</span
            >
          </div>
        </div>

        <div class="issue-viewall">
          <button
            type="button"
            class="issue-viewall-link"
            (click)="goToTabIndex(1)"
          >
            View all issues
            <span class="issue-viewall-arrow" aria-hidden="true">→</span>
          </button>
        </div>
      </div>

      <!-- Standings -->
      <div class="bottom-card" *ngIf="standings.length">
        <h3 class="card-title">Overall standings</h3>
        <div class="standings-list">
          <div
            *ngFor="let row of standings"
            class="standing-row"
            [class.standing-row--you]="row.isYou"
          >
            <span class="standing-rank">{{ row.rank }}</span>
            <span
              class="standing-name"
              [style.color]="row.nameColor"
              [style.font-weight]="row.weight"
              >{{ row.name }}</span
            >
            <div class="standing-bar-track">
              <div
                class="standing-bar-fill"
                [style.width]="row.barWidth"
                [style.background]="row.barColor"
              ></div>
            </div>
            <span class="standing-score" [style.color]="row.barColor"
              >{{ row.score }}<small class="standing-score-max">/100</small></span
            >
          </div>
        </div>

        <!-- No competitor tracked yet — offer to add one right here, so it's
             discoverable without hunting for the sub-bar chip. -->
        <div
          class="standings-add"
          *ngIf="canAddCompetitor && !competitors.length"
        >
          <span class="standings-add-text"
            >No competitor tracked yet — add one to benchmark your scores.</span
          >
          <button
            type="button"
            class="standings-add-btn"
            (click)="addCompetitor()"
          >
            + Add competitor
          </button>
        </div>

        <p class="standings-note" *ngIf="standingsNote">{{ standingsNote }}</p>
      </div>
    </div>
  </ng-container>
  </div>

  <!-- Competitor switch overlay (scoped to the content, below the sub-bar) -->
  <div class="loading-data-overlay" *ngIf="competitorSwitching$ | async">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <!-- ===== LOADING OVERLAY ===== -->
  <div class="loading-data-overlay" *ngIf="isLoading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
